import React from 'react';

export const PrivacyPolicy = () => {
  return (
    <div className="bg-slate-50 dark:bg-slate-950 min-h-screen">
      <div className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 pt-24 pb-16 relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/10 rounded-full blur-3xl" />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 bg-blue-600/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6 border border-blue-500/30">
              <span className="text-blue-300 text-3xl font-bold">P</span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">Política de Privacidade</h1>
            <p className="text-slate-300 text-lg max-w-xl mx-auto"> 
              Saiba como coletamos, usamos e protegemos seus dados.
            </p>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-xl border border-slate-200 dark:border-slate-800 p-8 md:p-10 -mt-8 relative z-20">
            <p className="text-slate-600 dark:text-slate-300 mb-8 leading-relaxed">
              Esta Política explica como coletamos, usamos e protegemos seus dados ao utilizar o site da PCS Dutos e Exaustores.
            </p>

            <div className="space-y-6">
              {[ 
                {
                  title: '1. Dados que coletamos',
                  body: 'Podemos coletar dados de cadastro (nome, e-mail), dados de entrega (endereços), dados de pedidos e informações técnicas do dispositivo e navegação (ex.: IP e páginas acessadas) para segurança e melhoria do serviço.'
                },
                {
                  title: '2. Como usamos os dados',
                  body: 'Usamos seus dados para processar pedidos, comunicar status de compra/entrega, fornecer suporte, prevenir fraudes e melhorar a experiência no site.'
                },
                {
                  title: '3. Compartilhamento',
                  body: 'Podemos compartilhar dados com prestadores de serviço essenciais (ex.: pagamento e logística) apenas na medida necessária para executar a operação. Não vendemos seus dados.'
                },
                {
                  title: '4. Cookies',
                  body: 'Utilizamos cookies para manter sua sessão e lembrar preferências. Você pode gerenciar cookies no navegador, mas isso pode afetar funcionalidades do site.'
                },
                {
                  title: '5. Segurança',
                  body: 'Adotamos medidas técnicas e organizacionais para proteger os dados. Ainda assim, nenhuma transmissão é 100% segura. Proteja suas credenciais e utilize senhas fortes.'
                },
                {
                  title: '6. Seus direitos',
                  body: 'Você pode solicitar acesso, correção ou exclusão de dados quando aplicável. Para isso, entre em contato pelos canais do site.'
                },
                {
                  title: '7. Alterações desta política',
                  body: 'Podemos atualizar esta Política periodicamente. Recomendamos revisar esta página.'
                },
              ].map((item) => (
                <section
                  key={item.title}
                  className="p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-700"
                >
                  <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">{item.title}</h2>
                  <p className="text-slate-600 dark:text-slate-300 text-sm leading-relaxed">{item.body}</p>
                </section>
              ))}
            </div>

            <p className="text-xs text-slate-400 dark:text-slate-500 mt-8 text-center">
              Última atualização: {new Date().toLocaleDateString('pt-BR')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
